<!-- Мониторинг -->
<template>
  <li
    v-if="canSeePage('telemetry')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Telemetry')"
    @mouseup="handleMiddleClick($event, 'Telemetry')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Telemetry')"
    :class="{ active: activeItem === 'telemetry' }"
    :title="collapsed ? 'Мониторинг' : ''"
  >
    <div class="link-icon_box">
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
          fill="#00bfa5"
        />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Мониторинг</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "TelemetryItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
